export const GOVGR_VISUALLY_HIDDEN = "govgr-visually-hidden";
export const GOVGR_GR_BUTTON_GROUP = "govgr-button-group";
